<template>
  <div>
    <div class="handle-search">
      <div class="search-box">
        <div class="searchItem">
          <el-date-picker
            v-model="query.startTime"
            style="width:130px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            @change="getData"
          ></el-date-picker>
          <span>&nbsp;-&nbsp;</span>
          <el-date-picker
            v-model="query.endTime"
            style="width:130px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            @change="getData"
          ></el-date-picker>
        </div>
        <div class="searchItem">
          <el-select
            @change="getData"
            v-model="query.userIds"
            size="small"
            style="width:230px"
            multiple
            clearable
            placeholder="请筛选店铺负责人"
          >
            <el-option
              v-for="item in shopPeopleArr"
              :key="item.userId"
              :value="item.userId"
              :label="item.userNickName"
            ></el-option>
          </el-select>
        </div>
        <!-- <div class="searchItem">
          <el-button size="small" type="primary" @click="handleSearch()" icon="el-icon-search">搜索</el-button>
          <el-button size="small" type="danger" @click="empty()" icon="el-icon-delete">清空</el-button>
        </div>-->
      </div>
      <div class="searchItem">
        <el-button
          size="small"
          type="primary"
          @click="isDataUpload=true"
          style="margin-left:10px;"
        >数据更新</el-button>
        <el-button size="small" type="primary" @click="showSetting()" style="margin-left:10px;">运营配置</el-button>
      </div>
    </div>
    <div class="bigData">
      <div class="icon">
        <p class="tit">
          <span class="el-icon-s-data"></span>
        </p>
        <span>数据概况</span>
      </div>
      <ul class="sumData">
        <li class="first">
          <p>
            <span class="title">营收总额</span>
            <span class="value">
              $
              <em class="num red">{{totalData.totalRevenue}}</em>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="title">毛利</span>
            <span class="value">
              $
              <em
                class="num"
                :class="{'green':totalData.totalGrossProfit<0,'red':totalData.totalGrossProfit>=0}"
              >{{totalData.totalGrossProfit}}</em>
            </span>
          </p>
          <p>
            <span class="title">毛利率</span>
            <span class="value">
              %
              <em
                class="num"
                :class="{'green':totalData.totalGrossProfitMargin<0,'red':totalData.totalGrossProfitMargin>=0}"
              >{{totalData.totalGrossProfitMargin}}</em>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="title">付款订单数</span>
            <span class="value">
              <em class="num red">{{totalData.totalPayOrderCount}}</em>
            </span>
          </p>
          <p>
            <span class="title">客单价</span>
            <span class="value">
              $
              <em class="num red">{{totalData.perCustomerTransaction}}</em>
            </span>
          </p>
        </li>
        <li class="first">
          <p>
            <span class="title">总广告费</span>
            <span class="value">
              $
              <em class="num green">{{totalData.totalAdvertisementFee}}</em>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="title">单均广告费</span>
            <span class="value">
              $
              <em class="num green">{{totalData.perOrderAdvertisementFee}}</em>
            </span>
          </p>
          <p>
            <span class="title">销售ROI</span>
            <span class="value">
              <em
                class="num"
                :class="{'green':totalData.totalROI<2,'red':totalData.totalROI>=2}"
              >{{totalData.totalROI}}</em>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="title">采购成本</span>
            <span class="value">
              $
              <em class="num green">{{totalData.totalPurchaseCost}}</em>
            </span>
          </p>
          <p>
            <span class="title">物流成本</span>
            <span class="value">
              $
              <em class="num green">{{totalData.totalLogisticsFee}}</em>
            </span>
          </p>
        </li>
        <li>
          <p>
            <span class="title">平台费用</span>
            <span class="value">
              $
              <em class="num green">{{totalData.totalPlatformServiceCharge}}</em>
            </span>
          </p>
          <p>
            <span class="title">支付手续费</span>
            <span class="value">
              $
              <em class="num green">{{totalData.totalPayServiceCharge}}</em>
            </span>
          </p>
        </li>
      </ul>
    </div>
    <el-table
      :data="tableData"
      border
      :height="tableHeight"
      ref="multipleTable"
      class="table"
      :row-key="setRowKey"
      :header-cell-style="{background:'#F3F4F7',color:'#555'}"
      :tree-props="{children: 'shopsData',hasChildren:'hasChildren'}"
    >
      <el-table-column prop="dateStr" label="日期"></el-table-column>
      <el-table-column label="店铺负责人" prop="name" width="180"></el-table-column>
      <el-table-column prop="grossProfit" label="毛利（$）"></el-table-column>
      <el-table-column prop="payOrderCount" label="付款订单数"></el-table-column>
      <el-table-column prop="revenue" label="营收（$）"></el-table-column>
      <el-table-column prop="advertisementFee" label="广告费（$）"></el-table-column>
      <el-table-column prop="purchaseCost" label="采购成本（￥）"></el-table-column>
      <el-table-column prop="logisticsFee" label="物流费（￥）"></el-table-column>
      <el-table-column prop="platformServiceCharge" label="平台手续费（$）"></el-table-column>
      <el-table-column prop="payServiceCharge" label="支付手续费（$）"></el-table-column>
      <el-table-column prop="exchangeLoss" label="汇损/签收（$）">
        <template slot-scope="scope">
          <div v-if="scope.row.errorMsg && scope.row.errorMsg.length>0">
            <el-popover trigger="hover" placement="top" style="cursor: pointer;">
              <p v-for="(item, index) in scope.row.errorMsg" :key="index">{{item}}</p>
              <div slot="reference" class="name-wrapper">
                {{scope.row.exchangeLoss}}
                <span class="el-icon-info" style="color:red"></span>
              </div>
            </el-popover>
          </div>
          <div v-else>{{scope.row.exchangeLoss}}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <el-dialog title="新增数据" :visible.sync="isAddData" width="500px">
      <el-form ref="form" :model="form" label-width="120px" width="40%">
        <el-form-item label="FB广告费用">
          <el-input v-model="form.name" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="点击量">
          <el-input v-model="form.name" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="FB购买次数">
          <el-input v-model="form.name" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="form.data"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddData = false">取 消</el-button>
        <el-button type="primary" @click="isAddData = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 运营配置 -->
    <el-dialog title="运营配置" :visible.sync="isSetting" width="500px">
      <el-form ref="form" :model="form1" label-width="120px" width="40%">
        <el-form-item label="采购成本系数">
          <el-input v-model="form1.procurementCostCoefficient" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="平台手续费系数">
          <el-input v-model="form1.platformCostCoefficient" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="支付手续费系数">
          <el-input v-model="form1.paymentCostCoefficient" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="支付手续费">
          <el-input v-model="form1.paymentCostAttach" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="汇损/签收">
          <el-input v-model="form1.exchangeLossCoefficient" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="人民币转美元">
          <span>
            1人民币&nbsp;=&nbsp;
            <el-input v-model="form1.currencyCNYToUSD" style="width:120px" placeholder="1人民币=多少美元"></el-input>&nbsp;美元
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isSetting = false">取 消</el-button>
        <el-button type="primary" @click="updateOperateConfig">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 数据更新 -->
    <el-dialog title="数据更新" :visible.sync="isDataUpload" width="400px">
      <el-date-picker
        v-model="startTime"
        style="width:130px"
        type="date"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="开始日期"
      ></el-date-picker>
      <span>&nbsp;-&nbsp;</span>
      <el-date-picker
        v-model="endTime"
        style="width:130px"
        type="date"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="结束日期"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDataUpload = false">取 消</el-button>
        <el-button type="primary" @click="updateOperateData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OperateDataInfo,
  UpdateOperateData,
  GetShopManagers,
  UpdateOperateConfig,
  GetOperateConfig
} from "@/utils/api";

Date.prototype.Format = function(fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

//生成从minNum到maxNum的随机数
function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
      break;
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      //或者 Math.floor(Math.random()*( maxNum - minNum + 1 ) + minNum );
      break;
    default:
      return 0;
      break;
  }
}

export default {
  data() {
    return {
      isAddData: false,
      tableHeight: 0,
      isSetting: false,
      searchDate: "",
      isExpand: false,
      startTime: this.getMonth("start"),
      endTime: this.getMonth("end"),
      isDataUpload: false,
      query: {
        pageStart: 1,
        limit: 20,
        startTime: this.getMonth("yesterday"),
        endTime: this.getMonth("yesterday"),
        userIds: []
      },
      pageTotal: 50,
      tableData: [],
      totalData: {},
      form: {},
      form1: {}, //运营配置
      shopPeopleArr: [
        {
          text: "店铺负责人",
          value: "1"
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.multipleTable) {
        this.tableHeight =
          window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 135;
      }
    });
  },
  methods: {
    handleSearch() {},
    getData() {
      OperateDataInfo(this.query).then(res => {
        if (res) {
          this.tableData = res.pageData.data;
          this.tableData = this.tableData.map(item => {
            if (item.shopsData.length > 0) {
              return {
                ...item,
                shopsData: item.shopsData.map((list, i) => {
                  return {
                    ...list,
                    num: randomNum(50000, 1000000)
                  };
                }),
                hasChildren: false
              };
            } else {
              return {
                ...item,
                hasChildren: true
              };
            }
          });
          this.pageTotal = res.pageData.totalData;
          this.totalData = res.totalData;

          if (this.totalData.totalRevenue > 10000000) {
            this.totalData.totalRevenue =
              this.totalData.totalRevenue / 10000 + "万";
          }

          if (this.totalData.totalGrossProfit > 10000000) {
            this.totalData.totalGrossProfit =
              this.totalData.totalGrossProfit / 10000 + "万";
          }
        }
      });
    },
    showSetting() {
      this.isSetting = true;
      GetOperateConfig().then(res => {
        if (res) {
          this.form1 = JSON.parse(JSON.stringify(res));
        }
      });
    },
    updateOperateConfig() {
      let {
        procurementCostCoefficient,
        platformCostCoefficient,
        currencyCNYToUSD,
        exchangeLossCoefficient,
        paymentCostAttach,
        paymentCostCoefficient
      } = this.form1;

      if (
        !procurementCostCoefficient ||
        !platformCostCoefficient ||
        !currencyCNYToUSD ||
        !exchangeLossCoefficient ||
        !paymentCostAttach ||
        !paymentCostCoefficient
      ) {
        this.$message.error(
          "采购成本系数、平台手续费系数、支付手续费系数、支付手续费、汇损/签收、人民币转美元都不能为空"
        );
        return;
      }
      UpdateOperateConfig({
        procurementCostCoefficient: Number(procurementCostCoefficient),
        platformCostCoefficient: Number(platformCostCoefficient),
        currencyCNYToUSD: Number(currencyCNYToUSD),
        exchangeLossCoefficient: Number(exchangeLossCoefficient),
        paymentCostAttach: Number(paymentCostAttach),
        paymentCostCoefficient: Number(paymentCostCoefficient)
      }).then(res => {
        if (res) {
          this.$message.success("运营数据更新成功");
          this.isSetting = false;
          this.getData();
        }
      });
    },
    setRowKey(row) {
      if (row.num) {
        return row.num;
      } else {
        return row.id;
      }
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageStart", val);
      this.getData();
    },
    sizeChange(val) {
      this.$set(this.query, "limit", val);
      this.getData();
    },
    updateOperateData() {
      let { startTime, endTime } = this;
      UpdateOperateData({
        startTime,
        endTime
      }).then(res => {
        if (res) {
          this.isDataUpload = this.getData();
        }
      });
    },
    getShopManagers() {
      GetShopManagers().then(res => {
        if (res) {
          this.shopPeopleArr = res;
        }
      });
    },
    getMonth(str) {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);

      var time = new Date().getTime() - 24 * 60 * 60 * 1000;
      var yesterday = new Date(time);
      var month = yesterday.getMonth();
      var day = yesterday.getDate();


      yesterday =
        yesterday.getFullYear() +
        "-" +
        (yesterday.getMonth() > 8
          ? yesterday.getMonth() + 1
          : "0" + (yesterday.getMonth() + 1)) +
        "-" +
        (yesterday.getDate() > 9
          ? yesterday.getDate()
          : "0" + yesterday.getDate());

         // console.log(yesterday)

      if (str == "start") {
        return firstDay.Format("yyyy-MM-dd");
      } else if (str == "yesterday") {
        
        return yesterday;
        return (
          yesterday.getFullYear() +
          "-" +
          (yesterday.getMonth() + 1) +
          "-" +
          yesterday.getDate()
        );
      } else {
        return lastDay.Format("yyyy-MM-dd");
      }
    }
  },
  created() {
    this.getShopManagers();
    this.getData();
  }
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 20px;
  padding: 20px 0;
}
.handle-search {
  background: #f3f3f3;
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  .search-box {
    display: flex;
    display: -webkit-flex;
    .searchItem {
      margin-right: 20px;
    }
  }
}
.handle-fun {
  margin: 20px 0;
}
.dataView {
  padding-bottom: 20px;
  .el-col {
    .box {
      border: 1px solid #ebedf8;
      background: #fff;
      border-radius: 5px;
      padding: 20px;
      .title {
        font-size: 14px;
      }
      .price {
        font-size: 24px;
        padding-top: 10px;
        span {
          &:first-child {
            font-size: 14px;
          }
        }
      }
    }
  }
}
table {
  width: 100%;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bigData {
  display: flex;
  display: -webkit-flex;
  width: 100%;
  padding-bottom: 20px;
  .tit {
    padding-top: 50px;
  }
  .icon {
    width: 80px;
    color: #fff;
    background: rgb(91, 137, 249);
    height: 150px;
    border-radius: 2px;
    text-align: center;
    .el-icon-s-data {
      color: #fff;
      font-size: 20px;
    }
  }
}
.sumData {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  li {
    width: calc(14% - 40px);
    height: 150px;
    padding: 0 20px;
    background: rgb(243, 246, 251);
    border-radius: 2px;
    &.first {
      p {
        padding: 50px 15px 15px;
        margin: 0 auto;
        &:first-child {
          border-bottom: 0;
        }
      }
    }
    p {
      padding: 15px;
      margin: 0 auto;
      &:first-child {
        border-bottom: 1px solid #eee;
      }
    }
    span {
      &.title {
        display: block;
        font-size: 12px;
      }
      &.value {
        font-size: 12px;
        margin-top: 8px;
        display: block;
        .num {
          font-size: 24px;
          margin-left: 2px;
          font-weight: bold;
        }
        .red {
          color: red;
        }
        .green {
          color: green;
        }
      }
    }
  }
}
</style>